module.exports = __webpack_public_path__ + "img/wncs-nav.a1c3334.svg";